<template>
  <div
    v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('view_receipt_and_confirm')"
    style="border: 0px solid black; width:100%;"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <div class="box box-success" v-show="true">
          <div
            class="box-header with-border"
            v-show="true"
            style="text-align:center; font-size: 14px;text-align:left;color:#5b6c7f;"
          >
            <h3 class="box-title">{{ $t("search.title") }}</h3>
          </div>
          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-md-12 col-ld-12 col-sd-12">
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="fa fa-paperclip"></i>
                    </span>
                    <input
                      v-on:keyup.enter="onSearchReceipt(1)"
                      type="text"
                      class="form-control"
                      :placeholder="$t('receipt.receipt_code')"
                      v-model="search.receipt_code"
                    />
                  </div>
                </div>
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="fa fa-home"></i>
                    </span>
                    <input
                      v-on:keyup.enter="onSearchReceipt(1)"
                      type="text"
                      class="form-control"
                      :placeholder="$t('apartment.apartment_code')"
                      v-model="search.apartment_code"
                    />
                  </div>
                </div>
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="fa fa-paperclip"></i>
                    </span>
                    <input
                      v-on:keyup.enter="onSearchReceipt(1)"
                      type="text"
                      class="form-control"
                      :placeholder="$t('receipt.from_invoice')"
                      v-model="search.from_invoice"
                    />
                  </div>
                </div>
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <date-picker
                      v-model="accountingPeriod"
                      @dp-change="onHandleChangeMonth(accountingPeriod)"
                      :config="optionsPicker"
                      :placeholder="$t('invoice.issuePeriod')"
                    ></date-picker>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-ld-12 col-sd-12"  style="margin-top: 10px;">
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <dateRangePicker
                      :dateFormat="'DD/MM/YYYY'"
                      @applyDatePicker="emitApplyDatePicker"
                      @clearDatePicker="emitClearDatePicker"
                    />
                  </div>
                </div>
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-user"></i>
                    </div>
                    <input
                      v-on:keyup.enter="onSearchReceipt(1)"
                      type="text"
                      class="form-control"
                      :placeholder="$t('receipt.user_created')"
                      v-model="search.user_created"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchReceipt(1)"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="box box-primary">
          <div class="box-header with-border">
            <row style="margin: 0">
              <div style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;">
                <h3 class="box-title">{{ $t("receipt.title") }}</h3>
                <lte-button
                  style="float:right;background-color:white !important;"
                  type="btn btn-default"
                  v-if="has_perm('print_receipt_and_confirm') || GET_ACCOUNT_DATA.id == 1"
                  right_icon="fa fa fa-print"
                  @click="onPrintReceiptByFilter($event)"
                >
                  {{ $t("common.printPdf") }}
                </lte-button>
                <lte-button
                  style="float:right"
                  type="btn btn-default"
                  right_icon="fa fa-download"
                  v-if="has_perm('export_receipt_and_confirm') || GET_ACCOUNT_DATA.id == 1"
                  @click="onExport"
                >
                  {{ $t("customer.export") }}
                </lte-button>
                <lte-button
                  style="float:right"
                  type="btn btn-primary"
                  right_icon="fa fa-plus"
                  v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('create_invoice')"
                  @click="importExcel"
                >
                  {{ $t("invoice.importFromExcel") }}
                </lte-button>
                <lte-button
                  style="float:right;"
                  type="btn btn-danger"
                  v-if="has_perm('delete_receipt_customer') || GET_ACCOUNT_DATA.id == 1"
                  right_icon="fa fa-trash"
                  @click="onDeleteReceiptSelect($event)"
                >
                  {{ $t("receipt.deletedReceipt") }}
                </lte-button>
              </div>
            </row>
            <div class="col-md-12" style="padding: 0">
              <select-option-check
                @callbackData="saveCustomizeTable"
                :item="columnsReceipt"
                class="dropdown-trigger"
                data-icon="eye">
              </select-option-check>
            </div>
          </div>
          <div class="box-header with-border">
            <row style="padding: 0;">
              <div class="col-md-12 col-sm-12" style="float:right; text-align: right">
                <div style="display: inline-block; margin-right: 10px;">
                  <p style="display: inline-block">{{ $t("receipt.totalReceipt") }}</p>
                  <p style="background-color: #42b983;padding: 4px 15px 4px 15px;display: inline-block;border: 1px solid #fff;color: #fff; border-radius: 5px;">
                    {{ total_receipt }}
                  </p>
                </div>
                <div style="display: inline-block; margin-right: 10px;">
                  <p style="display: inline-block">{{ $t("receipt.pay_amount") }}</p>
                  <p style="background-color: #c9302c;padding: 4px 15px 4px 15px;display: inline-block;border: 1px solid #fff;color: #fff; border-radius: 5px;">
                    {{ total_amount }}
                  </p>
                </div>
              </div>
              <div class="col-md-12 col-sm-12" style="float:right; text-align: right; font-size: 0.9em;">
                <div style="display: inline-block; margin-right: 10px;">
                  <p style="display: inline-block">{{ $t("receipt.numOfSelected") }}</p>
                  <p style="background-color: #42b983;padding: 4px 15px 4px 15px;display: inline-block;border: 1px solid #fff;color: #fff; border-radius: 5px;">
                    {{ list_receipt_id.length }}
                  </p>
                </div>
                <div style="display: inline-block; margin-right: 10px;">
                  <p style="display: inline-block">{{ $t("receipt.pay_amount") }}</p>
                  <p style="background-color: #c9302c;padding: 4px 15px 4px 15px;display: inline-block;border: 1px solid #fff;color: #fff; border-radius: 5px;">
                    {{ selected_amount }}
                  </p>
                </div>
              </div>
            </row>
          </div>
          <div class="box-body">
            <lte-table
              :hdBackground="hdBackground"
              :data="gridReceiptDataList"
              :columns="gridColumns"
              search_filter="left-search"
              @actions="crudActions"
              :actions="getReceiptAction()"
              :useCheckBox="useCheckBox"
              @selectedItems="selectedItems"
              :useFilter="useFilter"
              :boxStyle="boxStyle"
              :isGetInformationInvoice="true">
            </lte-table>
          </div>
        </div>
        <div class="box-footer clearfix" style="display:contents;">
          <paginator :item="paginatorItem" @onpaginate="onPagination" />
        </div>
        <lte-modal
          v-show="isModalVisible"
          @onConfirm="onConfirm"
          @close="closeModal"
          v-for="obj in objModal"
          :key="obj.id"
          :item="obj">
        </lte-modal>
        <!--  -->
        <lte-modal
          v-show="isModalSelectReceiptDelete"
          @onConfirm="onConfirmSelectReceiptDelete"
          @close="closeModalSelectReceiptDelete"
          v-for="obj in objModalSelectReceiptDelete"
          :key="obj.id"
          :item="obj">
        </lte-modal>
        <!--  -->
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar">
        </lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF">
        </loading>
      </row>
    </div>
    <!--  -->
    <receipt-detail-modal ref="receiptDetailModal"/>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { LTEActionTypeEnum } from '@/components/LTEEnum'
import LTEButton from "@/components/LTEButton.vue";
import LTETable from "@/components/LTETable.vue";
import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import SelectOptionCheck from "@/components/SelectOptionCheck.vue";
import ReceiptDetailModal from "./ReceiptDetailModal"
import Paginator from "@/components/Paginator.vue";
import Loading from "vue-loading-overlay";
import i18n from "../../lang";
import utils from "@/lib/utils";
import moment from "moment";
import datePicker from "vue-bootstrap-datetimepicker";
import DateRangePicker from '@/components/LTEDateRangePickerCustom.vue'
import ReceiptTypeEnum from "@/enum/receiptTypeEnum";
import XLSX from "xlsx";

export default {
  name: "ReceiptList",
  data() {
    return {
      buttonName: "danger",
      labelName: "Name",
      total_receipt: 0,
      total_amount: 0,
      selected_amount: 0,
      gridReceiptDataList: [],
      useFilter: false,
      boxStyle: false,
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "receipt.receipt_code", isHidden: true, wrapText: 'nowrap' },
        { text: "receipt.apartment_code", isHidden: true, align: 'center', wrapText: 'nowrap' },
        { text: "receipt.payer", isHidden: true, wrapText: 'nowrap' },
        { text: "receipt.actual_amount_from_customer", isHidden: true },
        { text: "receipt.balance", isHidden: true },
        { text: "receipt.monthlyCycle", isHidden: true, align: 'center' },
        { text: "receipt.fee_collection_date", isHidden: true, wrapText: 'nowrap' },
        // { text: "receipt.receipt_created", isHidden: true },
        // { text: "receipt.receipt_type", isHidden: true },
        // { text: "receipt.expected_amount", isHidden: true },
        { text: "receipt.user_created", isHidden: true, wrapText: 'nowrap' },
        { text: "receipt.from_invoice", isHidden: true },
        { text: "receipt.from_invoice_type", isHidden: true, wrapText: 'nowrap' },
        { text: "common.notes", isHidden: true, width: '200px' }
      ],
      columnsReceipt: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      //actions: ["common.modify", "common.printPdf"], // "common.modify", "common.delete"
      actions: ["common.printPdf"], // "common.modify", "common.delete"
      hdBackground: "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
      tblBorder: "border: 1px solid orange",
      originalRecordData: [],
      isModalVisible: false,
      objModal: [
        {
          title: "common.delete_modal.title",
          body: "common.delete_modal.content",
          buttonNo: "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      dateOptions: {
        format: "DD-MM-YYYY hh:mm a"
      },
      paginatorItem: {
        commit_function: "GET_Receipt_LIST"
      },
      optionsPicker: {
        useCurrent: false,
        minDate: new Date(2019, 0),
        // maxDate: moment().format("YYYY/MM"),
        format: "YYYY/MM",
        locale: this.$i18n.locale == "en" ? "en" : "vi"
      },
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },
      search: {
        receipt_code: "",
        from_invoice: "",
        apartment_code: "",
        receipt_created: "",
        user_created: "",
        dateCreatedReceipt: {
          start: null,
          end: null
        }
      },
      isLoading: false,

      useCheckBox: true,
      list_receipt_id: [],
      accountingPeriod: moment().format("YYYY/MM"),
      accountingPeriodClone: null,
      // seach month
      used_wallet: false,
      objModalSelectReceiptDelete: [
        {
          title: "common.delete_modal.btnYes",
          body: "receipt.notiConfirmDeleteReceiptSelect",
          buttonNo: "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      isModalSelectReceiptDelete: false
    };
  },
  watch: {
    GET_LANG: function() {
      this.optionsPicker.locale = this.$i18n.locale == "en" ? "en" : "vi";
    },
    GET_RECEIPT_DATA: function() {
      let result = this.GET_RECEIPT_DATA;
      this.total_receipt = utils.formatNumber(result.total_item)
      this.total_amount = utils.formatNumber(utils.makeRoundNumber(result.total_amount))
      this.gridReceiptDataList = [];
      result.list_items.forEach((receipt, i) => {
        let nonumber = i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let receipt_code = receipt.receipt_code;
        let payer = receipt.payer;
        let receipt_created = utils.formatSqlDate(receipt.date_created, null, "DD/MM/YYYY hh:mm:ss");
        //let expected_amount = utils.formatNumber(utils.makeRoundNumber(receipt.expected_amount));
        // let expected_amount = utils.formatNumber(
        //   utils.makeRoundNumber(receipt.amount)
        // );
        // Get actual amount
        let expected_amount = 0;
        expected_amount = receipt.amount
        expected_amount = utils.formatNumber(utils.makeRoundNumber(expected_amount));
        // let actual_amount =utils.formatNumber(receipt.actual_amount) ;
        let apartment_code = !utils.isNull(receipt.apartment) ? receipt.apartment.apartment_code : null;

        let user_created = utils.getFullName(
          receipt.user_first_name,
          receipt.user_last_name,
          i18n.locale
        );
        let id = receipt.id;
        let accountingPeriod = receipt.accounting_period
        let feeCollectionDate = utils.formatSqlDate(receipt.fee_collection_date, null, "DD/MM/YYYY");
        let balance = !utils.isEmptyString(receipt.balance)
          ? utils.formatNumber(utils.makeRoundNumber(receipt.balance)) : null
        let data = {
          "common.nonumber": nonumber,
          "receipt.receipt_code": receipt_code,
          "receipt.receipt_created": receipt_created,
          "receipt.payer": payer,
          "receipt.receipt_type": this.getReceiptTypeName(receipt.receipt_type),
          // "receipt.expected_amount": expected_amount,
          "receipt.actual_amount_from_customer": expected_amount,
          from_invoice_id: receipt.from_invoice.id,
          "receipt.from_invoice": receipt.from_invoice.invoice_number,
          "receipt.from_invoice_type": this.$t(utils.getInvoiceTypeString(receipt.from_invoice.group_type)),
          "receipt.apartment_code": apartment_code,
          "receipt.user_created": user_created,
          "receipt.monthlyCycle": this.convertMonthlyCycle(accountingPeriod),
          "receipt.fee_collection_date": feeCollectionDate,
          "receipt.balance": balance,
          receipt_receipt_type: receipt.receipt_type,
          "common.notes": receipt.description,
          id: id
        };
        this.gridReceiptDataList.push(data);
      });

      return this.gridReceiptDataList;
    },
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
      if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
        // let newGridColumns = [];
        const viewedColumnsKey = Object.keys(
          this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
        );
        const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
          .viewed_columns;
        for (
          let j = 0, sizeOrigin = this.gridColumns.length;
          j < sizeOrigin;
          j++
        ) {
          // for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
          //   if (this.gridColumns[j].text == viewedColumnsKey[i]) {
          //     let viewdColumnObject = {};
          //     viewdColumnObject.text = viewedColumnsKey[i];
          //     viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
          //     newGridColumns.push(viewdColumnObject);
          //     break;
          //   }
          // }
          if (viewedColumnsKey.length > 0){
            if (viewedColumns[this.gridColumns[j].text]) {
              this.gridColumns[j].isHidden = viewedColumns[this.gridColumns[j].text];
            } else {
              this.gridColumns[j].isHidden = false
            }
          }
        }
        // this.gridColumns = newGridColumns;
        this.columnsReceipt.data_list = this.gridColumns;
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "GET_LANG",
      "GET_ACCOUNT_DATA",
      "PAGE_ARROW",
      "GET_RECEIPT_DATA",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA"
    ])
  },
  created() {
  },
  methods: {
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    convertMonthlyCycle: function(monthlyCycleText) {
      // monthlyCycleText is 202105
      // ==> year: 2021, month: 05
      let month = ''
      let year = ''
      let results = ''
      if (!utils.isEmptyString(monthlyCycleText)) {
        let text = monthlyCycleText
        month = text.slice(4, 6)
        year = text.slice(0, 4)
        results = `${month}/${year}`
      }
      return results
    },
    onExport: function() {
      let exported_data = [];

      this.gridReceiptDataList.forEach(v => {
        let item = {
          STT: v["common.nonumber"],
          "Số Phiếu Thu	": v["receipt.receipt_code"],
          "Khách Hàng	": v["receipt.receipt_created"],
          "Ngày Lập Phiếu": v["receipt.payer"],
          "Hình Thức": v["receipt.receipt_type"],
          "Số Tiền Đã Thu": v["receipt.actual_amount_from_customer"],
          "Dư Nợ": this.formatBalance(v["receipt.balance"]),
          "Mã Căn Hộ": v["receipt.apartment_code"],
          "Người Thu": v["receipt.user_created"]
        };
        exported_data.push(item);
      });
      var data = XLSX.utils.json_to_sheet(exported_data);
      var wscols = [
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 }
      ];
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "receipt");
      data["!cols"] = wscols;
      // export Excel file
      XLSX.writeFile(wb,
        `ReceiptList_` + `${utils.formatSqlDate(this.accountingPeriod, "YYYY/MM", "YYYYMM")}.xlsx`
      ); // name of the file is 'book.xlsx'
    },
    formatBalance: function(value) {
      if (value < 0) {
        return `(${value})`
      }
      return value
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onPrintReceiptByFilter: function() {
      if (this.list_receipt_id.length === 0) {
        this.showError("receipt.errorSelectReceipt")
      } else {
        let routeData = this.$router.resolve({
          name: "ReceiptPdfFilter",
          query: {
            ids: this.list_receipt_id.join(",")
          }
        });
        window.open(routeData.href, "_blank");
      }
    },
    selectedItems: function(list_receipt) {
      this.list_receipt_id = []
      let count_amount = 0
      list_receipt.forEach(data=> {
        this.list_receipt_id.push(data.id)
        count_amount += parseInt(utils.formatInteger(data["receipt.actual_amount_from_customer"]));
      })
      this.selected_amount = utils.formatNumber(count_amount)
    },
    getReceiptTypeName(receipt_type) {
      if (receipt_type == ReceiptTypeEnum.CASH) {
        return this.$t("apartmentbookings.paymentBooking.typeList.cash")
      } else if (receipt_type == ReceiptTypeEnum.BANK_TRANSFER) {
        return this.$t("apartmentbookings.paymentBooking.typeList.bank_transfer")
      } else if (receipt_type == ReceiptTypeEnum.WALLET) {
        return this.$t("apartmentbookings.paymentBooking.typeList.wallet")
      }
      return ""
    },
    getFullNameByLanguage(first_name, last_name) {
      if (data != null) {
        return utils.getFullName(first_name, last_name, i18n.locale);
      }
      return "";
    },
    validateDateSearch: function () {
      let dataList = [
        this.search.receipt_code,
        this.search.apartment_code,
        this.search.from_invoice,
        this.search.user_created,
        this.search.dateCreatedReceipt.start]
      let findIsNull = dataList.find( x=> { if (!utils.isEmptyString(x)) return x } )
      if (findIsNull === undefined) {
        this.accountingPeriod = this.accountingPeriodClone
      }
    },
    onSearchReceipt: function(page) {
      this.validateDateSearch()
      const data = {
        params: {
          page: page,
          receiptCode: this.search.receipt_code,
          fromInvoice: this.search.from_invoice,
          apartmentCode: this.search.apartment_code,
          accountingPeriod: utils.formatSqlDate(this.accountingPeriod, "YYYY/MM", "YYYYMM"),
          dateCreatedReceiptFrom: this.search.dateCreatedReceipt.start,
          dateCreatedReceiptTo: this.search.dateCreatedReceipt.end,
          userCreated: this.search.user_created
        }
      };
      this.isLoading = true;
      this.GET_RECEIPT_LIST(data).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
    },
    saveCustomizeTable: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "receiptlist";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(
          function() {
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    clickToSmallBox() {
      alert("click!!!: clickToSmallBox");
    },
    addNew: function() {
      this.$router.push({
        name: "ReceiptAdd",
        params: {
          id: 0
        }
      });
    },
    crudActions: function(recordData, actionsType, isModalVisible) {
      if (actionsType == LTEActionTypeEnum.MODIFY) {
        this.$refs.receiptDetailModal.onShowReceiptDetail(recordData.id)
      } else if (actionsType == LTEActionTypeEnum.PRINT) {
        let name = "ReceiptPdf_TM";
        if (
          recordData.receipt_receipt_type != ReceiptTypeEnum.CASH &&
          recordData.receipt_receipt_type != ReceiptTypeEnum.WALLET
        )
          name = "ReceiptPdf_CK";

        let routeData = this.$router.resolve({
          name: name,
          params: {
            id: recordData.id
          }
        });
        window.open(routeData.href, "_blank");
      } else {
        this.originalRecordData = recordData;
        this.isModalVisible = isModalVisible;
      }
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_RECEIPT(this.originalRecordData)
        .then(
          function() {
            let currentPage = this.PAGINATION.page;
            let totalPage = this.PAGINATOR.length;
            let page =
              currentPage >= totalPage && this.gridReceiptDataList.length == 1
                ? totalPage - 1
                : currentPage;
            this.onSearchReceipt(page);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    onPrevPagination: function() {
      const data = {
        url: this.PAGE_ARROW.prev,
        commit_funtion: "GET_RECEIPT_LIST"
      };
      this.PAGINATION_PREV_PAGE(data);
    },
    onNextPagination: function() {
      const data = {
        url: this.PAGE_ARROW.next,
        commit_funtion: "GET_RECEIPT_LIST"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },
    onPagination: function(data) {
      this.onSearchReceipt(data.params.page);
    },
    closeModal() {
      this.isModalVisible = false;
    },
    importExcel: function() {
      this.$router.push({
        name: "ReceiptImportExcel"
      });
    },
    getReceiptAction: function() {
      let action = []
      if (this.has_perm("update_receipt_and_confirm")) {
        action.push('common.modify')
      }
      if (this.has_perm("print_receipt_customer")) {
        action.push("common.printPdf")
      }
      if (this.has_perm("delete_receipt_customer")) {
        action.push("common.delete")
      }
      return action
    },
    emitApplyDatePicker: function(data) {
      this.search.dateCreatedReceipt.start = data.start_date
      this.search.dateCreatedReceipt.end = data.end_date
    },
    emitClearDatePicker: function(data) {
      this.search.dateCreatedReceipt.start = data.start_date
      this.search.dateCreatedReceipt.end = data.end_date
    },
    onHandleChangeMonth: function(value) {
      this.accountingPeriodClone = utils.getCleanStringValue(this.accountingPeriod, this.accountingPeriodClone)
    },
    onDeleteReceiptSelect: function() {
      if (this.list_receipt_id.length === 0) {
        this.showError("receipt.errorSelectReceipt")
      } else {
        this.isModalSelectReceiptDelete = true
      }
    },
    closeModalSelectReceiptDelete: function() {
      this.isModalSelectReceiptDelete = false
    },
    onConfirmSelectReceiptDelete: function() {
      this.isModalSelectReceiptDelete = false;
      let data = {
        ids: this.list_receipt_id
      }
      this.DELETE_RECEIPT_SELECT_LIST(data)
        .then(
          function() {
            this.list_receipt_id = []
            let currentPage = this.PAGINATION.page;
            let totalPage = this.PAGINATOR.length;
            let page = currentPage >= totalPage && this.gridReceiptDataList.length == 1
                ? totalPage - 1 : currentPage;
            this.onSearchReceipt(page);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "GET_RECEIPT_LIST",
      "DELETE_RECEIPT",
      "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "DELETE_RECEIPT_SELECT_LIST"
    ])
  },
  mounted() {
    this.accountingPeriodClone = this.accountingPeriod
    this.columnsReceipt.data_list = this.gridColumns;
    const filter = {
      params: {
        tablename: "receiptlist"
      }
    };
    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
    this.onSearchReceipt(1);
  },

  components: {
    "date-picker": datePicker,
    "lte-button": LTEButton,
    "lte-table": LTETable,
    "lte-modal": LTEModal,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    loading: Loading,
    "select-option-check": SelectOptionCheck,
    DateRangePicker,
    ReceiptDetailModal
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Receipt/ReceiptList.vue